import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { getAllBlogPosts } from "../../../methods/blog/blogRequests";
import { Delete, Edit } from "@mui/icons-material";
import { callBackendApi } from "../../../methods/axiosInstances/backendInstance/apiRequest";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../store/snackbarSlice/snackbarSlice";

const AdminBlogPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const newBlogPost = () => {
    navigate("/dashboard/blog/create-blog-article");
  };

  const goToBlogPost = (id) => {
    navigate(`/dashboard/blog/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this blog post?"
      );
      if (!confirmDelete) return;

      const response = await callBackendApi(`/blog/${id}`, "DELETE");

      if (response && response.success) {
        dispatch(showSnackbar({ message: "Blog post deleted successfully!" }));

        await getBlogPosts();
      } else {
        dispatch(
          showSnackbar({
            message:
              "Something went wrong while deleting the blog post. Please try again.",
          })
        );
      }
    } catch (error) {
      console.error("Error deleting blog post:", error);
      dispatch(
        showSnackbar({
          message: "An error occurred while deleting the blog post.",
        })
      );
    }
  };

  const [blogPosts, setBlogPosts] = React.useState([]);

  React.useEffect(() => {
    getBlogPosts();
  }, []);

  const getBlogPosts = async () => {
    const response = await getAllBlogPosts();
    if (response.success) {
      setBlogPosts(response.data);
    } else {
      setBlogPosts([]);
    }
  };

  const columns = [
    {
      field: "image_url",
      headerName: "Thumbnail",
      width: 100,
      renderCell: (params) => (
        <img
          src={params.row.image_url}
          alt="thumbnail"
          style={{
            width: "80px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "5px",
          }}
        />
      ),
    },
    { field: "title", headerName: "Title", flex: 1, minWidth: 150 },
    { field: "slug", headerName: "Slug", flex: 1, minWidth: 150 },
    {
      field: "user",
      headerName: "User",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => <p>{params.row.user?.name || "Unknown"}</p>,
    },
    {
      field: "created_at",
      headerName: "Creation Date",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Fragment>
          <IconButton
            onClick={() => goToBlogPost(params.row.id)}
            color="primary"
          >
            <Edit />
          </IconButton>
          <IconButton
            className="mx-1"
            onClick={() => handleDelete(params.row.id)} // Call the delete handler
            color="error" // Use error color for delete button
          >
            <Delete />
          </IconButton>
        </Fragment>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", maxWidth: "1700px", margin: "auto" }}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h1>Blog</h1>
            </Grid>
            <Grid item xs={4}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                onClick={newBlogPost}
              >
                New Blog Post
              </Button>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%" }}>
              <DataGrid
                rows={blogPosts}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                slots={{ toolbar: GridToolbar }}
                autoHeight
                sx={{
                  width: "100%",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#222", // Darker header for better visibility
                    color: "#fff",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #444",
                  },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminBlogPage;
